import React, { Component, Fragment } from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Tooltip, Input, Space, Select } from 'antd';
import { checkNameFormat } from '@/services/helper/nameFormatCheck';
import debounce from '@/services/helper/debounceFn';
import '../../publicCss/style.css';
import "../../publicCss/aurora.css";
import "../../publicCss/tree.css";

/**
 * 
 * @param {{ItemTypes: [{ type: "select", options, eleName, defaultValue, disabled}, "name-input"]}} props
 */
class CreateItem extends Component {
  constructor(props) {
    super(props);
    const { itemData } = props;
    this.state = {
      name: itemData.name,
      errorMsg: null,
      valueObj: {}
    }
  }

  nameChange = (e) => {
    this.setState({
      errorMsg: null,
      name: e.target.value
    })
  }

  createConfirm = (e, itemData) => {
    e.stopPropagation();
    debounce(() => {
      this.createItemSave(itemData);
    }, 1000, true, 'createTimer')();
  }

  createItemSave = (itemData) => {
    const { name, valueObj } = this.state;
    //check name format
    let errorMsg = checkNameFormat(name);
    if (errorMsg) {
      this.setState({
        errorMsg: errorMsg
      });
      return;
    }

    const { projectList } = this.props;
    let _filter = projectList.filter(i => i.id !== itemData.id);
    let names = _filter.map(item => item.name);
    //check name repeated
    if (names.includes(name)) {
      this.setState({
        errorMsg: `${name} already exists!`
      });
      return;
    }

    //create project
    this.props.createConfirm({
      ...itemData,
      name,
      ...(Object.keys(valueObj).length > 0 ? { otherValue: { ...valueObj } } : {})
    });
    this.setState({
      errorMsg: null,
      autoFocus: false,
      name
    });
  }

  cancelCreate = (e) => {
    e.stopPropagation();
    this.setState({
      errorMsg: null,
      // name: null
    });
    this.props.cancelCreate();
  }

  inputClick = (e) => {
    e.stopPropagation();
  }

  onSelect = (value, eleName) => {
    this.setState((prevState) => {
      return {
        valueObj: {
          ...prevState.valueObj,
          [eleName]: value
        }
      }
    })
  }

  SelectItem = (item, key) => {
    const { valueObj } = this.state;
    return <Select
      key={key}
      style={{ width: item.width }}
      value={valueObj[item.eleName] || item.defaultValue}
      onChange={(value) => this.onSelect(value, item.eleName)}
      popupMatchSelectWidth={false}
      options={item.options || []}
      disabled={item.disabled}
    />
  }

  InputItem = (key) => {
    const { name } = this.state;
    const { createNodeId, cancelNodeId, itemData } = this.props;

    return <Input
      key={key}
      value={name}
      className='aurora-project-name-input'
      onChange={(e) => this.nameChange(e)}
      ref={(input) => { this.inputRef = input; }}
      onPressEnter={(e) => { e.stopPropagation(); this.createConfirm(e, itemData) }}
      onClick={(e) => this.inputClick(e)}
      addonAfter={<Fragment>
        <CloseOutlined
          className='aurora-tree-create-icon'
          id={createNodeId}
          onClick={(e) => this.cancelCreate(e, itemData)} />
        <CheckOutlined
          className='aurora-tree-create-icon mg-r-8'
          id={cancelNodeId}
          onClick={(e) => this.createConfirm(e, itemData)} />
      </Fragment>}
    />
  }

  render() {
    const { errorMsg } = this.state;
    const { itemData, getPopupContainer, ItemTypes = [{ type: 'name-input' }] } = this.props;
    return (
      <span className='aurora-project-create-name' key={itemData.key} onClick={(e) => this.inputClick(e)}>
        <Tooltip
          className='aurora-error-tooltip'
          title={errorMsg ? errorMsg : null}
          classNames={{ root: 'aurora-error-msg-tooltip' }}
          open={errorMsg ? true : false}
          getPopupContainer={getPopupContainer ? getPopupContainer : () => document.getElementsByClassName('my-tree')[0]}
        >
          <Space.Compact className=''>
            {ItemTypes.map((item, index) => {
              switch (item.type) {
                case 'select':
                  return this.SelectItem(item, `${item.type}-${index}`);
                case 'name-input':
                  return this.InputItem(`${item.type}-${index}`);
                default:
                  return null;
              }
            })}
          </Space.Compact>
        </Tooltip>
      </span>
    );
  }
}

export default CreateItem;